import { useTranslation } from 'react-i18next';
import { __ as Basic__, n__ as BasicN__, ns__ as BasicNs__, s__ as BasicS__, t as BasicT__, } from './lib';
export { interpolate } from './interpolation';
const isBrowser = typeof window !== 'undefined';
export const useI18n = () => {
    let isProviderAvailable = false;
    let t = (str, _) => { var _a, _b; return (isBrowser && ((_b = (_a = window.I18n) === null || _a === void 0 ? void 0 : _a.t) === null || _b === void 0 ? void 0 : _b.call(_a, str))) || BasicT__(str, _); };
    try {
        const translation = useTranslation();
        if (translation.ready) {
            isProviderAvailable = true;
            t = translation.t;
        }
    }
    catch (_a) {
    }
    const __ = (str) => {
        var _a;
        if (isProviderAvailable) {
            const translatedText = t(str);
            if (translatedText !== str) {
                return translatedText;
            }
        }
        return (isBrowser && ((_a = window.__) === null || _a === void 0 ? void 0 : _a.call(window, str))) || Basic__(str);
    };
    const s__ = (str) => {
        var _a;
        if (isProviderAvailable) {
            const translatedText = t(str);
            if (translatedText !== str) {
                return translatedText;
            }
        }
        return (isBrowser && ((_a = window.s__) === null || _a === void 0 ? void 0 : _a.call(window, str))) || BasicS__(str);
    };
    const n__ = (singular, plural, count) => {
        var _a;
        if (isProviderAvailable) {
            const translatedText = t(singular, { count });
            if (translatedText !== singular) {
                return translatedText;
            }
        }
        return ((isBrowser && ((_a = window.n__) === null || _a === void 0 ? void 0 : _a.call(window, singular, plural, count))) ||
            BasicN__(singular, plural, count));
    };
    const ns__ = (singular, plural, number, customVars = {}) => {
        var _a;
        const interpolationVars = Object.assign(Object.assign({}, customVars), { count: number });
        const matches = singular.match(/%\{(\w+)\}/gu);
        if (matches) {
            for (const match of matches) {
                const key = match.slice(2, -1);
                if (!(key in interpolationVars)) {
                    interpolationVars[key] = match;
                }
            }
        }
        if (isProviderAvailable) {
            const translatedText = t(singular, interpolationVars);
            if (translatedText !== singular) {
                return translatedText;
            }
        }
        return ((isBrowser && ((_a = window.ns__) === null || _a === void 0 ? void 0 : _a.call(window, singular, plural, number))) ||
            BasicNs__(singular, plural, number));
    };
    return { __, s__, n__, ns__, t };
};
//# sourceMappingURL=useI18n.js.map